import $ from "jquery";
  
Drupal.behaviors.expandableBox = {
  attach: function() {
    function checkWidth() {
      var windowSize = window.innerWidth;
      if (windowSize <= 760) {
        $('.expandable').remove();
        $('.btn-active').removeClass('.btn-active');
        $('.coworker--teaser').after("<div class='expandable'></div>");
        $('.coworker--teaser:last-child').after("<div class='expandable'></div>");
      }

      else if (windowSize <= 960) {
        $('.expandable').remove();
        $('.btn-active').removeClass('.btn-active');
        $('.coworker--teaser:nth-child(2n)').after("<div class='expandable'></div>");
        $('.coworker--teaser:last-child').after("<div class='expandable'></div>");
      }

      else if (windowSize <= 1200) {
        $('.expandable').remove();
        $('.btn-active').removeClass('.btn-active');
        $('.coworker--teaser:nth-child(3n)').after("<div class='expandable'></div>");
        $('.coworker--teaser:last-child').after("<div class='expandable'></div>")
      }

      else if (windowSize > 1200) {
        $('.expandable').remove();
        $('.btn-active').removeClass('.btn-active');
        $('.coworker--teaser:nth-child(4n)').after("<div class='expandable'></div>");
        $('.coworker--teaser:last-child').after("<div class='expandable'></div>");
      }
    }

    const debounce = (callback, delay = 100) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          callback(...args);
        }, delay);
      };
    };

    checkWidth();

    const debounceCheck = debounce(checkWidth, 100);

    var cachedWidth = window.innerWidth;
    $(window).resize(function(){
      var newWidth = window.innerWidth;
      if(newWidth !== cachedWidth){
        debounceCheck();
        cachedWidth = newWidth;
      }
    });
  }
};
